import React, { useState, useEffect } from "react";
import EmployeeForm from "./EmployeeForm";
import MUIDataTable from "mui-datatables";
import useFetch from "../services/employeeService";
import PageHeader from "../components/PageHeader";
import PeopleOutlineTwoToneIcon from "@material-ui/icons/PeopleOutlineTwoTone";
import {
  Paper,
  makeStyles,
  Toolbar,
  Grid,
  InputAdornment,
  CircularProgress,
  Typography,
} from "@material-ui/core";
import useTable from "../components/useTable";
import * as employeeService from "../services/employeeService";
import Controls from "../components/controls/Controls";
import { Search } from "@material-ui/icons";
import AddIcon from "@material-ui/icons/Add";
import IconButton from "@material-ui/core/IconButton";
import Popup from "../components/Popup";
import EditOutlinedIcon from "@material-ui/icons/EditOutlined";
import CloseIcon from "@material-ui/icons/Close";
import Notification from "../components/Notification";
import Loading from "../components/Loading";
import ConfirmDialog from "../components/ConfirmDialog";
import { useHistory, Redirect, Link } from "react-router-dom";
import axios from "axios";
const isISODate = require("is-iso-date");

const useStyles = makeStyles((theme) => ({
  pageContent: {
    margin: theme.spacing(5),
    padding: theme.spacing(3),
  },
  searchInput: {
    width: "75%",
  },
  // newButton: {
  //   position: "absolute",
  //   right: "10px",
  // },
  newButton: {
    float: "right",
    marginTop: "14px",
    marginRight: "14px",
  },
}));

export default function UseTables(props) {
  const {
    initialTitle,
    header,
    Icon,
    initialApiEndpoint,
    extraColumns,
    Form,
    extraFormToOpen = false,
    searchBox = true,
    startDateFilter = false,
    endDateFilter = false,
    districtFilter = true,
    cropFilter = true,
    cropTypeFilter = true,
    farmerId = null,
  } = props;
  const [{ data: crops }] = useFetch("get", "/crop", null);
  const classes = useStyles();
  const [title, setTitle] = useState(initialTitle);
  const [recordForEdit, setRecordForEdit] = useState(null);
  const [profilePhotoSaved, setProfilePhotoSaved] = useState(null);
  const [farmlandPhotoSaved, setFarmlandPhotoSaved] = useState(null);
  const [lat, setLat] = useState(null);
  const [long, setLong] = useState(null);
  // const [count, setCount] = useState(0)
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const date = new Date();
  const [start, setStart] = useState(
    new Date(date.getFullYear(), date.getMonth(), 1)
  );
  const [end, setEnd] = useState(new Date());
  const [params, setParams] = useState({
    offset: 0,
    limit: rowsPerPage,
    start: startDateFilter ? start : undefined,
    end: endDateFilter ? new Date().toISOString() : undefined,
    farmerId: farmerId ? farmerId : undefined,
    // siteId: "229d83b6-9972-4b1c-91cf-d2290ba41099",
  });
  const [searchText, setSearchText] = useState("");
  // const [error, setError] = useState(null);
  // const [isLoading, setIsLoading] = useState(true);
  // const [records, setRecords] = useState([]);
  const history = useHistory();
  const [
    { data: records, isLoading, count, error },
    fetchData,
    fetchOtherData,
    sendData,
    deleteData,
  ] = useFetch("get", initialApiEndpoint, params);
  const [openPopup, setOpenPopup] = useState(false);
  const [notify, setNotify] = useState({
    isOpen: false,
    message: "",
    type: "",
  });
  const [confirmDialog, setConfirmDialog] = useState({
    isOpen: false,
    title: "",
    subTitle: "",
  });

  const options = {
    // filter: true,
    // filterType: "dropdown",
    search: false,
    responsive: "standard",
    selectableRowsHeader: false,
    selectableRows: "none",
    serverSide: true,
    sort: false,
    sortOrder: {},
    count: count,
    rowsPerPage: rowsPerPage,
    rowsPerPageOptions: [10, 25, 50, 100],
    onChangePage: (currentPage) => {
      // console.log(currentPage);
      setParams({
        ...params,
        offset: currentPage * rowsPerPage,
        limit: rowsPerPage,
      });
    },
    onChangeRowsPerPage: (numberOfRows) => {
      // console.log(numberOfRows);
      setRowsPerPage(numberOfRows);
      setParams({
        ...params,
        offset: page * numberOfRows,
        limit: numberOfRows,
      });
    },
    onFilterChange: (
      changedColumn,
      filterList,
      type,
      changedColumnIndex,
      displayData
    ) => {
      // console.log(
      //   "filter change",
      //   changedColumn,
      //   filterList,
      //   changedColumnIndex,
      //   displayData
      // );
      setParams({
        [changedColumn]: filterList[changedColumnIndex][0],
        offset: 0,
        limit: rowsPerPage,
      });
      // console.log(params);
    },
  };
  const changeSearchText = (e) => {
    setSearchText(e.target.value);
    // console.log(searchText);
  };
  const handleTextSearch = () => {
    // console.log(params);
    setParams({
      ...params,
      name: searchText,
    });
    // console.log(params);
  };
  const resetSearch = () => {
    // console.log(params);
    setSearchText("");
    setParams({
      ...params,
      name: null,
    });
    // console.log(params);
  };

  const handleSearch = (event, value, reason, id) => {
    // const array = event.target.id.split("-");
    // const param = array[0];
    // console.log(event.target.id, value, reason, id);
    if (reason === "select-option")
      setParams({
        ...params,
        [id]: value.id,
        offset: 0,
        limit: rowsPerPage,
      });
    if (reason === "clear")
      setParams({
        ...params,
        [id]: undefined,
        offset: 0,
        limit: rowsPerPage,
      });
  };

  const handleDateChange = (event) => {
    const date = event.target.value.toISOString();
    const param = event.target.name;
    if (param === "start") setStart(event.target.value);
    if (param === "end") setEnd(event.target.value);
    setParams({
      ...params,
      [param]: date,
      offset: 0,
      limit: rowsPerPage,
    });
  };

  const addOrEdit = async (record, id, resetForm) => {
    // console.log("record", record);
    let error, isSuccess;
    if (id === null || id === undefined) {
      // console.log(record.dateOfBirth);
      if (record.dateOfBirth && !isISODate(record.dateOfBirth)) {
        record.dateOfBirth = record.dateOfBirth.toISOString();
        // console.log(record.dateOfBirth);
      }

      // record = JSON.stringify(record);
      // console.log(record);
      const res = await sendData(
        "post",
        initialApiEndpoint,
        record,
        initialApiEndpoint,
        params
      );
      error = res.error;
      isSuccess = res.isSuccess;
    } else {
      const res = await sendData(
        "put",
        `${initialApiEndpoint}/${id}`,
        record,
        // employeeDataForUpdate,
        initialApiEndpoint,
        params
      );
      error = res.error;
      isSuccess = res.isSuccess;
    }
    if (isSuccess) {
      resetForm();
      setRecordForEdit(null);
      setOpenPopup(false);
      setNotify({
        isOpen: true,
        message: "Submitted Successfully",
        severity: "success",
        title: "Success",
      });
    } else if (error) {
      setNotify({
        isOpen: true,
        message: error,
        severity: "error",
        title: "Error",
      });
    }
  };

  const openInPopup = async (item) => {
    const recordForEdit = item;
    setTitle(`Edit ${initialTitle}`);
    // console.log("recordForEdit", recordForEdit);
    // if (recordForEdit.email == null) recordForEdit.email = "";
    if (recordForEdit.profilePhoto) {
      const res = await fetchOtherData(
        "get",
        `/image?key=${recordForEdit.profilePhoto}`,
        null
      );
      setProfilePhotoSaved(res.data.imageData);
    }
    if (recordForEdit.farmlandPhoto) {
      const res = await fetchOtherData(
        "get",
        `/image?key=${recordForEdit.farmlandPhoto}`,
        null
      );
      setFarmlandPhotoSaved(res.data.imageData);
    }
    if (recordForEdit.coordinates) {
      setLat(recordForEdit.coordinates.coordinates[1]);
      setLong(recordForEdit.coordinates.coordinates[0]);
    }
    // recordForEdit.deletedAt = undefined;
    // recordForEdit.departureDate = undefined;
    // recordForEdit.site = undefined;
    // recordForEdit.siteId = undefined;
    // console.log(recordForEdit);
    setRecordForEdit(recordForEdit);
    // console.log(item);
    setOpenPopup(true);
  };

  const onDelete = async (item) => {
    let error, isSuccess;
    // console.log(item.id);
    setConfirmDialog({
      ...confirmDialog,
      isOpen: false,
    });
    const res = await deleteData(
      "delete",
      `${initialApiEndpoint}/${item.id}`,
      null,
      initialApiEndpoint,
      params
    );
    // fetchData("get", "/record", params);
    error = res.error;
    isSuccess = res.isSuccess;
    if (isSuccess) {
      setNotify({
        isOpen: true,
        message: "Deleted Successfully",
        severity: "success",
        title: "Success",
      });
    } else if (error) {
      setNotify({
        isOpen: true,
        message: error,
        severity: "error",
        title: "Error",
      });
    }
  };
  const onClose = () => {
    setOpenPopup(false);
    setProfilePhotoSaved(null);
    setFarmlandPhotoSaved(null);
    setLat(null);
    setLong(null);
  };

  const columns = [
    ...extraColumns,
    {
      name: "Actions",
      options: {
        filter: false,
        sort: false,
        empty: true,
        customBodyRenderLite: (dataIndex, rowIndex) => {
          return (
            <React.Fragment>
              {extraFormToOpen && (
                <Link
                  style={{ textDecoration: "none" }}
                  to={`/farmers/${records[rowIndex].id}/crops`}
                >
                  <Controls.Button
                    text="Manage Crops"
                    color="default"
                    size="small"
                  />
                </Link>
              )}
              <Controls.ActionButton
                color="primary"
                onClick={() => {
                  openInPopup(records[rowIndex]);
                }}
              >
                <EditOutlinedIcon fontSize="small" />
              </Controls.ActionButton>
              {/* <Controls.ActionButton
                color="secondary"
                onClick={() => {
                  setConfirmDialog({
                    isOpen: true,
                    title: "Are you sure to delete this record?",
                    subTitle: "You can't undo this operation",
                    onConfirm: () => {
                      onDelete(records[rowIndex]);
                    },
                  });
                }}
              >
                <CloseIcon fontSize="small" />
              </Controls.ActionButton> */}
            </React.Fragment>
          );
        },
      },
    },
  ];
  return (
    <>
      <PageHeader
        title={`${header}`}
        subTitle={`${header} list`}
        icon={<Icon fontSize="large" />}
      />
      <Paper className={classes.pageContent}>
        <Grid container spacing={3}>
          {startDateFilter && (
            <Grid item xs={12} md={4}>
              <Controls.DatePicker
                name="start"
                label="Start Date"
                value={start}
                views={["year", "month"]}
                onChange={handleDateChange}
              />
            </Grid>
          )}
          {endDateFilter && (
            <Grid item xs={12} md={4}>
              <Controls.DatePicker
                name="end"
                label="End Date"
                value={end}
                views={["year", "month"]}
                onChange={handleDateChange}
              />
            </Grid>
          )}

          {districtFilter && (
            <Grid item xs={12} md={4}>
              <Controls.AutoComplete
                id="district"
                label="District"
                options={employeeService.getDistrictsCollection()}
                getOptionLabel={(option) => option.title}
                getOptionSelected={(option, value) =>
                  option.title === value.title
                }
                onChange={(event, value, reason) =>
                  handleSearch(event, value, reason, "district")
                }
              />
            </Grid>
          )}
          {searchBox && (
            <Grid item xs={12} md={4}>
              <Controls.Input
                label={`Search ${header}`}
                value={searchText}
                className={classes.searchInput}
                InputProps={{
                  endAdornment: (
                    <InputAdornment
                      position="end"
                      style={{ cursor: "pointer" }}
                    >
                      {searchText && (
                        <IconButton onClick={resetSearch}>
                          <CloseIcon fontSize="small" />
                        </IconButton>
                      )}
                      <IconButton onClick={handleTextSearch}>
                        <Search />
                      </IconButton>
                    </InputAdornment>
                  ),
                }}
                onChange={changeSearchText}
              />
            </Grid>
          )}
          {cropFilter && (
            <Grid item xs={12} md={4}>
              <Controls.AutoComplete
                id="cropId"
                label="Crop"
                options={crops}
                getOptionLabel={(option) => option.name}
                onChange={(event, value, reason) =>
                  handleSearch(event, value, reason, "cropId")
                }
              />
            </Grid>
          )}
          {cropTypeFilter && (
            <Grid item xs={12} md={4}>
              <Controls.AutoComplete
                id="cropType"
                label="Crop Type"
                options={[
                  { id: "Organic", title: "Organic" },
                  { id: "Non Organic", title: "Non Organic" },
                ]}
                getOptionLabel={(option) => option.title}
                getOptionSelected={(option, value) => option.id === value.id}
                onChange={(event, value, reason) => {
                  // console.log("event, value, reason", event, value, reason);
                  handleSearch(event, value, reason, "cropType");
                }}
              />
            </Grid>
          )}
        </Grid>
      </Paper>
      {/* <Paper className={classes.pageContent}>
        <Toolbar>
         
          <Controls.Button
            text="Add New"
            variant="outlined"
            startIcon={<AddIcon />}
            className={classes.newButton}
            onClick={() => {
              setOpenPopup(true);
              setTitle(`Add New ${initialTitle}`);
              setRecordForEdit(null);
            }}
          />
        </Toolbar>
      </Paper> */}
      <Controls.Button
        text="Add New"
        // variant="outlined"
        style={{ zIndex: 5 }}
        startIcon={<AddIcon />}
        className={classes.newButton}
        onClick={() => {
          setOpenPopup(true);
          setTitle(`Add New ${initialTitle}`);
          setRecordForEdit(null);
        }}
      />
      <div>
        <MUIDataTable
          title={
            <Typography variant="h6">
              {`${header} list`}
              {isLoading && (
                <CircularProgress
                  size={24}
                  style={{ marginLeft: 15, position: "relative", top: 4 }}
                />
              )}
            </Typography>
          }
          data={records}
          columns={columns}
          options={options}
        />
      </div>
      <Popup
        title={title}
        openPopup={openPopup}
        setOpenPopup={setOpenPopup}
        onClose={onClose}
      >
        <Form
          recordForEdit={recordForEdit}
          addOrEdit={addOrEdit}
          farmlandPhotoSaved={farmlandPhotoSaved}
          profilePhotoSaved={profilePhotoSaved}
          lat={lat}
          long={long}
        />
      </Popup>
      <Loading isLoading={isLoading} />
      <Notification notify={notify} setNotify={setNotify} />
      <ConfirmDialog
        confirmDialog={confirmDialog}
        setConfirmDialog={setConfirmDialog}
      />
    </>
  );
}
